'use strict';

var self = module.exports = {
	init: function () {

		if (document.querySelectorAll('[data-js="video-youtube"]').length > 0) {

			var tag = document.createElement('script');
			var firstScriptTag = document.getElementsByTagName('script')[0];
			var listYoutubeVideo = document.querySelectorAll('[data-js="video-youtube"]');

			tag.src = "https://www.youtube.com/iframe_api";
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

			for (var i = 0; i < listYoutubeVideo.length; i++) {
				window['player_' + i] = listYoutubeVideo[i];
			}

			global.onYouTubeIframeAPIReady = function () {

				for (var i = 0; i < listYoutubeVideo.length; i++) {
					window['player_' + i] = new YT.Player(window['player_' + i].id, {
						height: 'auto',
          				width: 'auto',
						videoId: window['player_' + i].dataset.videoId,
						host: 'https://www.youtube.com',
						suggestedQuality: 'hd1080',
						playerVars: {
							'modestbranding': 1,
							'rel': 0,
							'controls': 1,
							'color': 'white',
							'origin': 'https://www.copiaincolla.com',
							'start': window['player_' + i].dataset.start,
							'end': window['player_' + i].dataset.end
						},
						events: {
							'onStateChange': onPlayerStateChange,
							'onPlaybackQualityChange': onPlaybackQualityChange
						}
					});
				}
			};

			global.onPlayerStateChange = function (event) {
				if (event.data === YT.PlayerState.PLAYING) {
					event.target.setPlaybackQuality('hd1080');
				}
			};

			global.onPlaybackQualityChange = function (event) {
				event.target.setPlaybackQuality('hd1080');
			}
		}
	}
};

self.init();